import { BehaviorSubject } from "rxjs";

const videoEnded$ = new BehaviorSubject<boolean>(true);
const currentVideoTime$ = new BehaviorSubject<number>(0);

export { videoEnded$, currentVideoTime$ };
